import { isDisplayable } from '../../../shared/utils/productUtils.js'

function compareByIdCad(a, b) {
  const aId = String(a?.id_cad ?? '')
  const bId = String(b?.id_cad ?? '')
  return aId.localeCompare(bId, undefined, { numeric: true, sensitivity: 'base' })
}

export function collectVisualizationPathIds(containerEl) {
  if (!containerEl) return new Set()

  return new Set(
    Array.from(containerEl.querySelectorAll('path[id]'))
      .map((path) => path.id)
      .filter(Boolean),
  )
}

export function buildVisualizationProductCandidates({
  containerEl,
  products = [],
}) {
  const pathIds = collectVisualizationPathIds(containerEl)
  if (pathIds.size === 0) return []

  return products
    .filter((product) => isDisplayable(product.visibility))
    .filter((product) => pathIds.has(product.id_cad))
    .sort(compareByIdCad)
}
